import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  const filtered = clients.filter(
    (c) => c.name.toLowerCase().includes(q.toLowerCase()) || (c.phone || "").includes(q)
  );

  return (
    <div data-testid="admin-clients" className="space-y-6">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <div>
          <h1 className="font-serif-display text-3xl">Clientes</h1>
          <p className="text-sm text-muted-foreground">{clients.length} registrados</p>
        </div>
        <input
          data-testid="clients-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por nombre o teléfono"
          className="w-full border border-border bg-card px-3 py-2 text-sm sm:w-72"
        />
      </div>

      <div className="overflow-x-auto border border-border">
        <table className="w-full text-sm">
          <thead className="border-b border-border bg-muted/50 text-left text-xs uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Nombre</th>
              <th className="px-4 py-3">Teléfono</th>
              <th className="px-4 py-3">Correo</th>
              <th className="px-4 py-3">Visitas</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.id} data-testid={`client-row-${c.id}`} className="border-b border-border last:border-0">
                <td className="px-4 py-3">{c.name}</td>
                <td className="px-4 py-3">{c.phone}</td>
                <td className="px-4 py-3 text-muted-foreground">{c.email || "—"}</td>
                <td className="px-4 py-3">
                  <span className="bg-primary/10 px-2 py-0.5 text-primary">{c.visits}</span>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-10 text-center text-muted-foreground">Sin clientes.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
